import { createTheme } from "@mui/material/styles"
import type { ThemeOptions } from "@mui/material/styles"
import { tokens } from "./theme/tokens"

export const themeOptions: ThemeOptions = {
  palette: {
    mode: "light",
    primary: {
      main: tokens.colors.accent.primary,
      contrastText: tokens.colors.text.onPrimary
    },
    secondary: {
      main: tokens.colors.accent.secondary
    },
    background: {
      default: tokens.colors.background.default,
      paper: tokens.colors.background.surface
    },
    text: {
      primary: tokens.colors.text.primary,
      secondary: tokens.colors.text.secondary
    },
    divider: tokens.colors.border
  },
  shape: {
    borderRadius: tokens.radius.base
  },
  typography: {
    fontFamily: tokens.typography.body,
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    h1: {
      fontFamily: tokens.typography.heading,
      fontWeight: 700,
      letterSpacing: "0.02em",
      textTransform: "uppercase",
      fontSize: "clamp(2.6rem, 6vw, 4.6rem)"
    },
    h2: {
      fontFamily: tokens.typography.heading,
      fontWeight: 700,
      letterSpacing: "0.02em",
      textTransform: "uppercase",
      fontSize: "clamp(2rem, 4.5vw, 3.2rem)"
    },
    h3: {
      fontFamily: tokens.typography.heading,
      fontWeight: 600,
      letterSpacing: "0.02em",
      textTransform: "uppercase"
    },
    h4: {
      fontFamily: tokens.typography.heading,
      fontWeight: 600,
      letterSpacing: "0.02em",
      textTransform: "uppercase"
    },
    h5: {
      fontFamily: tokens.typography.heading,
      fontWeight: 600,
      letterSpacing: "0.01em",
      textTransform: "uppercase"
    },
    button: {
      fontWeight: 700,
      letterSpacing: "0.08em"
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: tokens.colors.background.default,
          color: tokens.colors.text.primary,
          backgroundImage:
            "linear-gradient(180deg, rgba(255, 251, 254, 1) 0%, rgba(234, 221, 255, 0.6) 100%), radial-gradient(40% 30% at 10% 10%, rgba(255, 216, 228, 0.5) 0%, transparent 60%)",
          backgroundAttachment: "fixed"
        },
        a: {
          color: "inherit",
          textDecoration: "none"
        },
        "*": {
          boxSizing: "border-box"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "uppercase",
          borderRadius: tokens.radius.base,
          paddingInline: "1.6rem",
          paddingBlock: "0.85rem",
          fontWeight: 700
        },
        containedPrimary: {
          color: tokens.colors.text.onPrimary,
          "&:hover": {
            boxShadow: tokens.shadows.soft
          }
        },
        outlinedPrimary: {
          borderColor: tokens.colors.accent.primary,
          color: tokens.colors.accent.primary,
          "&:hover": {
            borderColor: tokens.colors.accent.primary,
            backgroundColor: "rgba(103, 80, 164, 0.08)"
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none"
        }
      }
    }
  }
}

const theme = createTheme(themeOptions)
export default theme
